<ng-container *ngIf="data?.children?.length">
  <mat-selection-list matSelectionList
                      hideSingleSelectionIndicator
                      [multiple]="false"
                      class="st-assignments-overlay">
    <mat-list-option *ngFor="let assignment of data.children"
                     [value]="assignment"
                     (click)="onObjectOpen.emit(assignment)">
      <icon [type]="assignment?.coverageType?.toUpperCase()"
            hasBorder
            class="st-assignments-overlay-icon"
            [record]="assignment"></icon>
      <avatar *ngIf="assignment.owner"
              class="st-assignments-overlay-avatar"
              horizontal-big
              [userId]="getUserID(assignment)"
              [label]="playbookService.globalTablesService.FieldDefsDict[pstFieldNames.PSTAssignmentOwner]?.DefaultCaption">
      </avatar>
    </mat-list-option>
  </mat-selection-list>
</ng-container>